export default "__VITE_ASSET__CtWx4xSG__"